import { JsonSerializable } from '../shared/jsonSerializable';
import { ThirdParty } from '../entity/third-party';
import { RequestStatus } from '../entity/request-status';
import * as moment from 'moment/moment';

export class Order extends JsonSerializable {

  type: string;
  number: string;
  receptionDate: string;
  effectiveDate: string;
  infos: any;
  objectRef: any;
  thirdPartyDmd: ThirdParty;
  thirdPartyAff: ThirdParty;
  status: RequestStatus;

  constructor() {
    super();
    this.type = null;
    this.number = null;
    this.receptionDate = null;
    this.effectiveDate = null;
    this.infos = null;
    this.objectRef = null;
    this.thirdPartyDmd = null;
    this.thirdPartyAff = null;
    this.status = null;
  }

  fromJSON(jsonObj: Object) {
    for (var propName in jsonObj) {
      if(Array.isArray(jsonObj[propName])){
        for (let i in jsonObj[propName]) {
          if(jsonObj[propName] instanceof Object){
            if (propName == "thirdParties") {
              let orderThirdParty = jsonObj[propName][i];
              let thirdParty = new ThirdParty();
              thirdParty.fromJSON(orderThirdParty['thirdParty']);
              if (orderThirdParty['type'] == "DMD") {
                this.thirdPartyDmd = thirdParty;
              } else if (orderThirdParty['type'] == "AFF") {
                this.thirdPartyAff = thirdParty;
              }
            } 
          } else {
            this[propName][i] = jsonObj[propName][i];
          }
        }
      } else {
        if (this.hasOwnProperty(propName)) {        
          if(jsonObj[propName] instanceof Object){
            if (propName == "status") {
              this[propName] = new RequestStatus();
            }
            this[propName].fromJSON(jsonObj[propName]);
          } else if ((propName=="infos")) {
            this[propName] = JSON.parse(jsonObj[propName]);
          } else {
            this[propName] = jsonObj[propName];
          }
        }      
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/entity/order.ts